import menusJson from '../config/sidebarMenus.json';
import urls from '../config/urls.json';
/**
* This class provides the very first route after the user has logged in based on the 
* role and the services he has access to and priority set in core_maintenance.js
*/
const RouteHelper = function(userStore){
	
	let USER_ROUTE = "";

	let allProdRoutes = [];
	let activeProdRoutes = [];

	let allowedEntls = [];
	let allEntls = [];

	const getContestHost = () =>{
		if(localStorage.getItem("contestType") && localStorage.getItem("contestType").length > 0){
			return localStorage.getItem("contestType").toUpperCase();
		}

		return null;
	}
	
	let isServiceRoute = (entlKey) => {
		let serviceRoutesEntls = window.serviceRoutesEntls || [];
		
		if(entlKey && serviceRoutesEntls && serviceRoutesEntls.length > 0){
			for(let i=0; i< serviceRoutesEntls.length; i++){
				if(entlKey.match(serviceRoutesEntls[i].replace("|","\\|"))){
					return true; 
				}
			}
		}

		return false;
	}

	(() => {
		let accessMap = userStore.getAccessMap();
		let userEntlHistory = userStore.getEntlHistory();
		let permissions = userStore.getPermissions();

		for(let i in userEntlHistory){
			try{
				let tempArr = userEntlHistory[i].split(",");
				let tempArr2 = (permissions[i]) ? permissions[i].split(",") : [];

				if(tempArr && ((tempArr.length > 0 && Number(tempArr[0]) > 0) || (tempArr.length > 1 && Number(tempArr[1]) > 0) || isServiceRoute(accessMap[i]))){
					allEntls.push(accessMap[i]);
				}

				if(tempArr2 && ((tempArr2.length > 0 && Number(tempArr2[0]) > 0) || (tempArr2.length > 1 && Number(tempArr2[1]) > 0) || isServiceRoute(accessMap[i]))){
					allowedEntls.push(accessMap[i]);
				}
			}catch(e){
				console.error(e);
			}			
		}
	})();

	let lastAccessedView = window.lastAccessedView || "lastAccessedView";

	let lastViewedRoute = userStore.getAttribute(lastAccessedView);
	
	if(window.save_path_preference && lastViewedRoute){
		USER_ROUTE = lastViewedRoute;
	}else if(menusJson){
		Object.values(menusJson).map((menu, index) =>{
			if(menu && (menu.route || menu.value)){
				if(~allEntls.indexOf(menu.entlKey)){
					allProdRoutes.push(menu.route || menu.value);
				}

				if(~allowedEntls.indexOf(menu.entlKey)){
					activeProdRoutes.push(menu.route || menu.value);
				}
			}
		});

		const contestHost = getContestHost() || "ALL";

		//Decide the route based on priority
		const priority_routes = (window.route_priority && window.route_priority[contestHost]);

		if(priority_routes && ((priority_routes[userStore.getRole()] && priority_routes[userStore.getRole()].length > 0) || (priority_routes["ALL"] && priority_routes["ALL"].length > 0))){
			let priorityRoutes = priority_routes[userStore.getRole()] || priority_routes["ALL"]; 
			if(priorityRoutes && priorityRoutes.length > 0){
				for(let i=0; i < priorityRoutes.length; i++){
					if(~activeProdRoutes.indexOf(priorityRoutes[i])){
						USER_ROUTE = priorityRoutes[i];
						break;
					}
				}

				if(!USER_ROUTE){
					for(let i=0; i < priorityRoutes.length; i++){
						if(~allProdRoutes.indexOf(priorityRoutes[i])){
							USER_ROUTE = priorityRoutes[i];
							break;
						}
					}
				}	
			}			
		}else{
			USER_ROUTE = activeProdRoutes[0] || activeProdRoutes[0];
		}		
	}else if(lastViewedRoute){
		USER_ROUTE = lastViewedRoute;
	}else{
		console.warn("menusJson not defined nor empty. No route defined.");
	}

	let findDomain = (route) => {
		let baseDomain = null;
		if(window.route_helper_route_domain_map && Object.keys(window.route_helper_route_domain_map).length > 0){
			for(let i in window.route_helper_route_domain_map){
				if(route.match(i)){
					baseDomain = urls[window.route_helper_route_domain_map[i]];
					break;
				}
			}
		}				

		if(!baseDomain){
			baseDomain = urls["WEB_DOMAIN"];
		}


		return baseDomain;	
	}

	let frameUrl = (route) => {
		if(urls && route){
			let baseDomain = findDomain(route);


			/**
			* Specific only to Dev Environment
			*/
			if(window.devMode && window.devHost){
				baseDomain = window.devHost;
			}

			if(baseDomain){
				if(~route.indexOf(window.location.origin) && !window.location.origin.match(baseDomain)){
					route.replace(window.location.host, baseDomain);
				}else if(~route.indexOf(window.location.host) && !window.location.origin.match(baseDomain)){
					route.replace(window.location.host, baseDomain);
				}else{
					route = (route.startsWith("/") ? baseDomain : baseDomain + "/") + route;
				}	

					//check for protocol header
					route = (~route.indexOf(window.location.protocol)) ? route : window.location.protocol + "//" + route; 
					return route;
				}
			}
		}

		return{
			getRoute:function(){
				return USER_ROUTE;
			},
			getUrl:function(){
				USER_ROUTE = frameUrl(USER_ROUTE);

				return (USER_ROUTE) ? USER_ROUTE : null;		
			},
			getDomain: function(route = null){
				return findDomain((route) ? route : window.location.pathname);
			},
			getLogOutUrl: function(authProviderId){
				if(window.devMode && window.devHost){
					return window.location.protocol + "//" + window.devHost;
				}

				if(authProviderId === 5){
					return window.location.protocol + "//" + urls["LUMOS_UM_DOMAIN"];
				}

				let logOutUrl = frameUrl(window.location.pathname);

				if(logOutUrl){
					try{
						return logOutUrl.split("/").slice(0,3).join("/");
					}catch(e){
						console.error(e);
					}
				}

				return window.location.protocol + "//" + urls["WEB_DOMAIN"];
			}
		};
	}

	export default RouteHelper;


// WEBPACK FOOTER //
// ./src/util/RouteHelper.js